import React from "react";
import { Nav, NavItem } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NavItems = (props: any) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Nav tabs>
        <NavItem>
          <Link style={{ cursor: "pointer" }} to={`#`} className="active nav-link">
            {t("Application")}
          </Link>
        </NavItem>

        <NavItem>
          <Link style={{ cursor: "pointer" }} to={`#`} className="nav-link">
            {t("Documents")}
          </Link>
        </NavItem>
      </Nav>
    </React.Fragment>
  );
};

export default NavItems;
